<template>
  <div class="h-9 rounded flex items-center overflow-hidden doc-page-controller">
    <button v-if="hasDraw || isRoomMode('CBT')"
            class="button bg-arrow-left-white"
            @click="movePage(doc.currDocPageSeq - 1, -1)"
    ></button>
    <form class="h-full px-2 py-1.5 flex items-center"
          @submit.prevent="movePage"
    >
      <label class="input-sizer"
             ref="pageInputSizer"
      >
        <input type="number"
               class="h-full rounded bg-white text-center input-hide-arrow"
               min="1"
               ref="pageInput"
               :max="maxPage"
               :value="doc.currDocPageSeq || ($refs.pageInput && $refs.pageInput.value)"
               :disabled="!hasDraw"
               @input.stop="input"
               @keyup.stop="keyup"
        />
      </label>

      <span class="mx-1.5 text-xs text-gray-100">/</span>
      <p class="text-xs text-gray-100">{{ maxPage }}</p>
    </form>
    <button v-if="hasDraw || isRoomMode('CBT')"
            class="button bg-arrow-right-white"
            @click="movePage(doc.currDocPageSeq + 1, 1)"
    ></button>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: 'RoomDocPaging',
  created() {
    window.addEventListener('keyup', this.keyupEvents);
  },
  destroyed() {
    window.removeEventListener('keyup', this.keyupEvents);
  },
  computed: {
    ...mapGetters('user', [
      'me'
    ]),
    ...mapGetters('doc', [
      'getCurrentRoomDocFile',
    ]),
    ...mapGetters('room', [
      'isRoomMode',
    ]),
    ...mapState('cbt', [
      'roomCBT',
    ]),
    doc: function() {
      return this.getCurrentRoomDocFile;
    },
    hasDraw: function() {
      return this.me.roomUserRole.draw;
    },
    maxPage: function() {
      if(!this.doc || !this.doc.pages){
          return 0;
      }
      return this.doc.pages.length;
    }
  },
  watch: {
    'doc.currDocPageSeq': function(page) {
      if (page) {
        this.$refs.pageInputSizer.dataset.value = page;
      }
    }
  },
  methods: {
    ...mapActions('doc', [
      'changeRoomDocPage',
    ]),
    ...mapActions('cbt', [
      'changeRoomCBTUserDocPage',
    ]),
    movePage(page, direction) {
      if (!this.me.roomUserRole.draw && !this.isRoomMode('CBT')) {
        return;
      }

      if(this.$refs.pageInput.value === '') this.$refs.pageInput.value = 1

      if (typeof page === 'object') {
        page = this.$refs.pageInput.value;
      }
      page = Number(page);

      if (direction !== undefined) {
        const val = Number(this.$refs.pageInput.value);
        if (direction < 0) {
          if (val === 1) return;
          this.$refs.pageInput.value = val - 1;
          page = Number(this.$refs.pageInput.value);
        } else if (direction > 0) {
          if (val === this.maxPage) return;
          this.$refs.pageInput.value = val + 1;
          page = Number(this.$refs.pageInput.value);
        }
      }

      clearTimeout(this._t_movePage);
      this._t_movePage = setTimeout(() => {
        const docPageId = this.doc.pages[page - 1].docPageId;
        const { roomGroupId, docId } = this.doc;

        if (this.isRoomMode('CBT')) {
          this.changeRoomCBTUserDocPage({ roomGroupId, docId, docPageId, roomCbtId: this.roomCBT.roomCbtId, userId: this.me.userId });
        } else {
          this.changeRoomDocPage({ roomGroupId,  docId,  docPageId });
        }

        this.$emit('paging', { roomGroupId,  docId,  docPageId })
      }, 300);
    },
    input(e) {
      const val = Number(e.target.value);
      if (val > this.maxPage) {
        e.target.value = this.maxPage;
      }

      this.$refs.pageInputSizer.dataset.value = e.target.value;
    },
    keyup(e) {
      const regExp = /[^0-9]/g;
      if (regExp.test(e.key)) {
        e.target.value = e.target.value.replace(regExp, '');
      }
      switch (e.keyCode) {
        case 27:
          this.$refs.pageInput.value = this.doc.currDocPageSeq;
          break;
        default:
          break;
      }
    },
    keyupEvents(e) {
      const { keyCode } = e;

      switch (keyCode) {
        case 33: // page up
        case 37: // left arrow
        case 38: // up arrow
          this.movePage(this.doc.currDocPageSeq - 1, -1);
          break;
        case 34: // page down
        case 39: // right arrow
        case 40: // down arrow
          this.movePage(this.doc.currDocPageSeq + 1, 1);
          break;
        case 36: // home
          this.movePage(1);
          break;
        case 35: // end
          this.movePage(this.maxPage);
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  @apply w-9 h-full transition-all opacity-80 hover:bg-gray-700 hover:opacity-100;
}

.doc-page-controller {
  background-color: rgba(0,0,0,0.8);
}

.input-sizer {
  height: 100%;
  display: inline-grid;
  vertical-align: top;
  align-items: center;
  position: relative;

  &::after,
  input {
    width: auto;
    min-width: 1em;
    grid-area: 1 / 2;
    box-sizing: border-box;
    margin: 0;
    padding: 0 0.5rem;
    font-size: 12px;
  }

  &::after {
    content: attr(data-value) ' ';
    visibility: hidden;
    white-space: pre-wrap;
  }
}
</style>